var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDoneAll({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5001 6.41665L15.2076 5.12415L9.39598 10.9358L10.6885 12.2283L16.5001 6.41665ZM20.3868 5.12415L10.6885 14.8225L6.85681 11L5.56431 12.2925L10.6885 17.4166L21.6885 6.41665L20.3868 5.12415ZM0.375977 12.2925L5.50014 17.4166L6.79264 16.1241L1.67764 11L0.375977 12.2925Z",
    fill: "#3956C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDoneAll);
export default __webpack_public_path__ + "static/media/iconDoneAll.4ab509806767350846ed7e68f3949fd2.svg";
export { ForwardRef as ReactComponent };